import { Navigate } from 'react-router-dom';
import { AdminGymsPage } from './AdminGymsPage.js';
import { AdminBookingsPage } from './AdminBookingsPage.js';
import { AdminUsersPage } from './AdminUsersPage.js';
import { AdminSlotsPage } from './AdminSlotsPage.js';
import { AdminFranchisePage } from './AdminFranchisePage.js';
import { AdminSettingsPage } from './AdminSettingsPage.js';
import { AdminEmailsPage } from './AdminEmailsPage.js';
import { AdminCreditsPage } from './AdminCreditsPage.js';
import { AdminReferralsPage } from './AdminReferralsPage.js';
import { AdminMembershipsPage } from './AdminMembershipsPage.js';
import { AdminPromoCodesPage } from './AdminPromoCodesPage.js';
import { useAuth } from '../../hooks/useAuth.js';

export type AdminSection =
  | 'gyms'
  | 'bookings'
  | 'users'
  | 'slots'
  | 'codes'
  | 'credits'
  | 'memberships'
  | 'promos'
  | 'referrals'
  | 'franchise'
  | 'emails'
  | 'settings';

interface AdminSectionPageProps {
  section: AdminSection;
}

export function AdminSectionPage({ section }: AdminSectionPageProps) {
  const { role } = useAuth();
  const operatorSections: AdminSection[] = ['bookings', 'users', 'settings'];
  if (role === 'GYM_STAFF' && !operatorSections.includes(section)) {
    return <Navigate to="/admin/bookings" replace />;
  }

  if (section === 'gyms') return <AdminGymsPage />;
  if (section === 'bookings') return <AdminBookingsPage />;
  if (section === 'users') return <AdminUsersPage />;
  if (section === 'slots') return <AdminSlotsPage />;
  if (section === 'codes') return <Navigate to="/admin/bookings" replace />;
  if (section === 'credits') return <AdminCreditsPage />;
  if (section === 'memberships') return <AdminMembershipsPage />;
  if (section === 'promos') return <AdminPromoCodesPage />;
  if (section === 'referrals') return <AdminReferralsPage />;
  if (section === 'franchise') return <AdminFranchisePage />;
  if (section === 'emails') return <AdminEmailsPage />;
  return <AdminSettingsPage />;
}
